import React, { useState, useEffect } from 'react';
import styles from './index.module.scss'
import { withRouter } from 'react-router-dom';
import icon_question from '../../static/images_ae/alkAsk/question.png';
import icon_answer from '../../static/images_ae/alkAsk/answer.png';
import utils from '../../utils/utils';
import { ApiCore } from '../../api';

const api = new ApiCore();

const AlkCommonAskDetail = (props: any) => {

    const [textData, setTextData] =  useState<any>({})
    const [urlParams, setUrlParams] =  useState<any>({})

    useEffect(() => {
        initData();
    }, [])

    const toPrePage= () => {
        if (urlParams.id) {
            props.history.go(-1);
        } else {
            props.onBefore();
        }
    }

    const initData = () => {
        const urlParams = utils.getUrlParams();
        const params = {
            questionId: props.articleId || urlParams.id
        };
        setUrlParams(urlParams);
        api.getQuestionDetail(params).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data;
                if (_data.template == '2') {
                    try {
                        _data.contentArr = JSON.parse(_data.content);
                    } catch (error) {
                        _data.contentArr = ['', ''];
                    }
                }
                setTextData(_data);
            }
        })
    }

    return (
        <div className={styles.common_ask_detail_container}>
            <div className={styles.title}>
                <img src={icon_question} alt="" />
                <div className={styles.text}>{textData.title}</div>
            </div>
            {/* <div className={styles.sub_title}>life</div> */}
            <div className={styles.content}>
                <div className={styles.content_lr}>
                    <div className={styles.t}></div>
                    <div className={styles.m}>
                        <div className={styles.m_l}></div>
                        <div className={styles.m_r}></div>
                    </div>
                    <div className={styles.b}></div>
                </div>
                {
                    textData.template == '1' || !textData.template ?
                    <div className={styles.content_m}>
                        <div dangerouslySetInnerHTML={{__html: textData.content || ''}}></div>
                        <img className={styles.icon_answer} src={icon_answer} alt="" />
                    </div>
                    :
                    textData.template == '2' ?
                    <div className={styles.content_m}>
                        <div dangerouslySetInnerHTML={{__html: textData.contentArr[0]}}></div>
                    </div>
                    :
                    null
                }

                <div className={styles.content_lr}>
                    <div className={styles.t}></div>
                    <div className={styles.m}>
                        <div className={styles.m_r}></div>
                        <div className={styles.m_l}></div>
                    </div>
                    <div className={styles.b}></div>
                </div>
            </div>
            {
               textData.template == '2' &&
               <div className={styles.content_m_b}>
                    <div className={styles.sub_content}  dangerouslySetInnerHTML={{__html: textData.contentArr[1]}}>
                    </div>
                    <div className={styles.icon_answer_wap}>
                        <img className={styles.icon_answer} src={icon_answer} alt="" />
                    </div>
               </div>
            }
            <div className={styles.pre_btn} onClick={() => { toPrePage() }}>
                <div className={styles.pre_item_btn} >返回上一页</div>
            </div>
        </div>
    )
}

export default withRouter(AlkCommonAskDetail);